'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class;

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _AsSeenOn = require('./AsSeenOn.scss');

var _AsSeenOn2 = _interopRequireDefault(_AsSeenOn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  AsSeenOn: {
    displayName: 'AsSeenOn'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Pachantiew/AsSeenOn.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var AsSeenOn = _wrapComponent('AsSeenOn')((_dec = (0, _reactCssModules2.default)(_AsSeenOn2.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(AsSeenOn, _Component);

  function AsSeenOn() {
    (0, _classCallCheck3.default)(this, AsSeenOn);
    return (0, _possibleConstructorReturn3.default)(this, (AsSeenOn.__proto__ || (0, _getPrototypeOf2.default)(AsSeenOn)).apply(this, arguments));
  }

  (0, _createClass3.default)(AsSeenOn, [{
    key: 'render',
    value: function render() {
      var newtvImg = require('./newtv.png');
      var postImg = require('./posttoday.png');
      var bangkokImg = require('./bangkok.png');
      var smartImg = require('./smartsme.png');
      var bangkokPImg = require('./bangkokpost.png');
      var thanImg = require('./than.png');
      var marketeerImg = require('./marketeer.png');
      var thaiImg = require('./thaipbs.png');
      var nineImg = require('./965fm.png');
      return _react3.default.createElement(
        'div',
        { styleName: 'container' },
        _react3.default.createElement(
          'div',
          { styleName: 'inner' },
          _react3.default.createElement(
            'div',
            { styleName: 'as-seen-on' },
            _react3.default.createElement(
              'h2',
              null,
              '\u0E1E\u0E1A\u0E01\u0E31\u0E1A\u0E1E\u0E27\u0E01\u0E40\u0E23\u0E32\u0E44\u0E14\u0E49\u0E17\u0E35\u0E48'
            ),
            _react3.default.createElement(
              'div',
              { styleName: 'row-as-seen-on' },
              _react3.default.createElement(
                'div',
                { styleName: 'as-seen-on-container' },
                _react3.default.createElement(
                  'div',
                  { styleName: 'half-as-seen-on' },
                  _react3.default.createElement(
                    'a',
                    { href: 'https://youtu.be/2vPjbmqQNYg?t=4m46s', target: '_blank', styleName: 'as-seen-link' },
                    _react3.default.createElement('img', { src: newtvImg, alt: 'New Tv' })
                  ),
                  _react3.default.createElement(
                    'a',
                    { href: 'http://www.posttoday.com/biz/news/431850', target: '_blank', styleName: 'as-seen-link' },
                    _react3.default.createElement('img', { src: postImg, alt: 'Post Today' })
                  ),
                  _react3.default.createElement(
                    'a',
                    { href: 'http://www.bangkokbiznews.com/blog/detail/637440', target: '_blank', styleName: 'as-seen-link' },
                    _react3.default.createElement('img', { src: bangkokImg, alt: 'Bangkok Biz' })
                  )
                ),
                _react3.default.createElement(
                  'div',
                  { styleName: 'half-as-seen-on' },
                  _react3.default.createElement(
                    'a',
                    { href: 'http://www.smartsme.tv/content/31870', target: '_blank', styleName: 'as-seen-link' },
                    _react3.default.createElement('img', { src: smartImg, alt: 'Smart SME' })
                  ),
                  _react3.default.createElement(
                    'a',
                    { href: 'http://www.bangkokpost.com/tech/local-news/968161/travelling-different', target: '_blank', styleName: 'as-seen-link' },
                    _react3.default.createElement('img', { src: bangkokPImg, alt: 'Bangkok Post' })
                  ),
                  _react3.default.createElement(
                    'a',
                    { href: 'http://www.thansettakij.com/2016/06/04/57983', target: '_blank', styleName: 'as-seen-link' },
                    _react3.default.createElement('img', { src: thanImg, alt: 'Than Settakij' })
                  )
                ),
                _react3.default.createElement(
                  'div',
                  { styleName: 'half-as-seen-on' },
                  _react3.default.createElement(
                    'a',
                    { href: 'http://marketeer.co.th/2016/06/take-me-tour1/', target: '_blank', styleName: 'as-seen-link' },
                    _react3.default.createElement('img', { src: marketeerImg, alt: 'Marketeer' })
                  ),
                  _react3.default.createElement(
                    'a',
                    { href: 'https://www.youtube.com/watch?v=t2RwbSfgRmg&feature=youtu.be&t=36m', target: '_blank', styleName: 'as-seen-link' },
                    _react3.default.createElement('img', { src: thaiImg, alt: 'ThaiPBS' })
                  ),
                  _react3.default.createElement(
                    'a',
                    { href: 'http://mcot-web.mcot.net/fm965/site/streaming/id/56e28fe593816351378b4705#.V4YMfZN96Cg', target: '_blank', styleName: 'as-seen-link' },
                    _react3.default.createElement('img', { src: nineImg, alt: '96.5 FM' })
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return AsSeenOn;
}(_react2.Component)) || _class));

exports.default = AsSeenOn;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/AsSeenOn.js
// module id = 669
// module chunks = 47